import React from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Dateput.css";

class Dateput extends React.Component {


   /* you have these props, which access to
   this.props.field, // { name, value, onChange, onBlur }
   this.props.form   // { touched, errors, values, setXXXX, handleXXXX, dirty, isValid, status, ...etc }.
    */
   constructor(props) {
    super(props);
    this.state = {
        // date: new Date()
    };
  }

  handleChange = value => {
    // call setFieldValue and manually update values
    this.setState({
      date: value
    });
    this.props.form.setFieldValue(this.props.field.name, value);
  };

  handleBlur = () => {
    // call setFieldTouched and manually update touched.topcis
    this.props.form.setFieldTouched(this.props.field.name, true);
  };

  render() {
    return (
        <DatePicker
          selected={this.state.date}
          onChange={val => {
            this.handleChange(val);
          }}
          locale={this.props.locale}
          dateFormat={this.props.dateFormat}
          placeholderText="* TT.MM.JJJJ"
        />
      );
  }
}

export default Dateput;

